import type { FC } from 'react';
import { Card, Stack, styled, Tooltip, Typography } from '@mui/material';
import { Button, Iconify } from '@pflegenavi/web-components';
import { DirectDebitStatus } from '@pflegenavi/shared/api';
import { useTranslation } from 'react-i18next';

export interface CancelDirectDebitMangopayViewProps {
  status: DirectDebitStatus;
  onCancelClick: () => void;
  isDisabled?: boolean;
}

export const CancelDirectDebitMangopayView: FC<
  CancelDirectDebitMangopayViewProps
> = ({ status, onCancelClick, isDisabled = false }) => {
  const { t } = useTranslation();

  if (status === DirectDebitStatus.Inactive) {
    return null;
  }

  return (
    <RootContainer>
      <Typography
        gutterBottom
        sx={{
          fontWeight: 700,
          ml: 1,
        }}
      >
        {t('mobile.family-member.status-update')}
      </Typography>
      <ContentContainer sx={{ alignItems: 'stretch' }} spacing={2}>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            fontWeight: 600,
          }}
        >
          {t('mobile.family-member.direct-debit-ready-to-use')}
        </Typography>
        <Typography
          variant="subtitle2"
          gutterBottom
          sx={{
            fontWeight: 600,
          }}
        >
          {t('mobile.family-member.direct-debit-want-to-cancel')}
        </Typography>

        <Stack
          sx={{
            alignItems: 'flex-end',
          }}
        >
          {isDisabled ? (
            <Tooltip title={t('direct-debit.cancel-blocked-payment-pending')}>
              <span>
                <Button
                  onClick={onCancelClick}
                  variant="contained"
                  color="error"
                  disabled
                  endIcon={<Iconify icon="bx:x" color="white" />}
                >
                  {t('direct-debit.cancel')}
                </Button>
              </span>
            </Tooltip>
          ) : (
            <Button
              onClick={onCancelClick}
              variant="contained"
              color="error"
              endIcon={<Iconify icon="bx:x" color="white" />}
            >
              {t('direct-debit.cancel')}
            </Button>
          )}
        </Stack>
      </ContentContainer>
    </RootContainer>
  );
};

const RootContainer = styled(Card)(({ theme }) =>
  theme.unstable_sx({
    p: 1,
    pt: 2,
    width: '100%',
    borderRadius: 3,
  })
);

const ContentContainer = styled(Stack)(({ theme }) =>
  theme.unstable_sx({
    bgcolor: 'grey.200',
    paddingX: 2,
    paddingY: 3,
    pb: 2,
    borderRadius: 3,
  })
);
